import { useEffect, useState } from "react"
import Styles from "./ControlCenter.module.scss"
import classnames from "classnames"

//Icons
import { ReactComponent as BrightnessIcon } from "../../icons/common/brightness.svg"
import { ReactComponent as SoundIcon } from "../../icons/extra_icons/saturation.svg"
import { ReactComponent as WifiIcon } from "../../icons/common/wifi.svg"
import { ReactComponent as BluetoothIcon } from "../../icons/common/bluetooth.svg"
import { ReactComponent as AirDropIcon } from "../../icons/common/airdrop.svg"
import { ReactComponent as ThemeIcon } from "../../icons/common/theme.svg"
import { ReactComponent as KeyboardLightcon } from "../../icons/common/keyboard_light.svg"
import { ReactComponent as MirrorIcon } from "../../icons/extra_icons/gallery_library.svg"



const ControlCenter = () => {

    const connectionOptions = [
        {
            id: "wifi",
            label: "Wifi",
            subTitle: "Home",
            icon: <WifiIcon />
        },
        {
            id: "bluetooth",
            label: "Bluetooth",
            icon: <BluetoothIcon />
        },
        {
            id: "air_drop",
            label: "Air Drop",
            subTitle: "Contacts Only",
            icon: <AirDropIcon />
        },
    ]

    const [settings, setSettings] = useState(
        {
            brightness: Number(document.documentElement.style.getPropertyValue(('--brightness'))) * 100.0 > 0 ? Number(document.documentElement.style.getPropertyValue(('--brightness'))) * 100 : 100,
            saturation: 100
        }
    )



    const handleBirghtness = (event: any) => {
        setSettings({
            ...settings,
            brightness: event.target.value
        })
        document.documentElement.style.setProperty(('--brightness'), String(event.target.value / 100))
    }

    const handleSaturation = (event: any) => {
        setSettings({
            ...settings,
            saturation: event.target.value
        })
        document.documentElement.style.setProperty(('--saturation'), String(event.target.value / 100))
    }


    return (
        <div className={classnames(Styles.container, "glassBackground")}>
            <div className={classnames(Styles.flex, Styles.column_flex)}>

                <div className={classnames(Styles.flex, Styles.row_flex)}>
                    <div className={classnames(Styles.flex, Styles.column_flex, Styles.block)} style={{ padding: "12px 8px" }}>
                        {
                            connectionOptions.map((option: any) => {
                                return (
                                    <div className={classnames(Styles.flex, Styles.row_flex)} key={option.id} >
                                        <div className={Styles.icon}>
                                            {option.icon}
                                        </div>
                                        <div className={Styles.info}>
                                            <div className={Styles.title}>
                                                {option.label}
                                            </div>
                                            <div className={Styles.sub_text}>
                                                {option.subTitle}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={classnames(Styles.flex, Styles.column_flex)}>
                        <div className={classnames(Styles.flex, Styles.column_flex)}>
                            <div className={classnames(Styles.block, Styles.row_flex)}>
                                <div className={classnames(Styles.flex, Styles.row_flex)}>
                                    <div className={Styles.icon}>
                                        <ThemeIcon />
                                    </div>
                                    <div className={Styles.title} style={{ maxWidth: "60px", padding: "4px 0" }}>
                                        Do Not Disturb
                                    </div>
                                </div>
                            </div>
                            <div className={classnames(Styles.flex, Styles.row_flex)}>
                                <div className={classnames(Styles.flex, Styles.column_flex, Styles.block)} style={{ justifyContent: "center", gap: "2px" }}>
                                    <div className={Styles.center}>
                                        <div className={classnames(Styles.icon, Styles.no_bg)}>
                                            <KeyboardLightcon />
                                        </div>
                                    </div>
                                    <div className={Styles.sub_text} style={{ textAlign: "center",  lineHeight:"8px" }}>
                                        Keyboard Brightness
                                    </div>
                                </div>
                                <div className={classnames(Styles.flex, Styles.column_flex, Styles.block)} style={{ justifyContent: "center", gap: "2px" }}>
                                    <div className={Styles.center}>
                                        <div className={classnames(Styles.icon, Styles.no_bg)}>
                                            <MirrorIcon />
                                        </div>
                                    </div>
                                    <div className={Styles.sub_text} style={{ textAlign: "center",  lineHeight:"8px" }}>
                                        Screen Mirroring
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className={classnames(Styles.slider_container, Styles.block)}>
                <div className={Styles.heading}>
                    Display
                </div>
                <input onChange={handleBirghtness} type="range" min={0} max={100} value={settings.brightness} className={Styles.slider} name="bri" id="bri" />

                <div className={Styles.slider_icon}>
                    <BrightnessIcon />
                </div>

            </div>
            <div className={classnames(Styles.slider_container, Styles.block)}>
                <div className={Styles.heading}>
                    Sound
                </div>
                <input onChange={handleSaturation} type="range" min={0} max={100} value={settings.saturation} className={Styles.slider} name="bri" id="bri" />

                <div className={Styles.slider_icon}>
                    <SoundIcon />
                </div>

            </div>
            <div className={Styles.music}>
                <iframe className={Styles.music_frame} src="https://open.spotify.com/embed/playlist/5u1XZZd8NNKauJc581CWSZ?utm_source=generator" frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>
            </div>
        </div>
    )
}

export default ControlCenter
